module.exports = __webpack_public_path__ + "img/ar17.38534bda.jpg";